import subjectsData from "./subjects.js";
import onlineOrShop from "./onlineOrShop.json";
import shop from "./shop.json";
import liveChat from "./liveChat.json";
import productAndStockInformation from "./1_productAndStockInformation.json";
import storeStockAvailability from "./1.1_storeStockAvailability.json";
import productInformation from "./1.2_productInformation.json";
import myJLMembership from "./2_myJLMembership";
import problemsWithProductData from "./3_problemsWithProduct.js";
import furnitureDamagedOnDelivery from "./3.1_furnitureDamagedOnDelivery.json";
import furnitureProductFault from "./3.2_furnitureProductFault.json";
import electrical from "./3.3_electrical.json";
import problemsOther from "./3.4_problemsOther.json";
import infestation from "./3.5_infestation.json";
import returns from "./4_returns.json";
import returnsShop from "./4.1_returnsShop.json";
import returnsOnline from "./4.2_returnsOnline.json";
import refunds from "./5_refunds.json";
import refundsShop from "./5.1_refundsShop.json";
import refundsOnline from "./5.2_refundsOnline.json";
import orderQueryData from "./6_orderQuery.js";
import amendOrder from "./6.1_amendOrder.json";
import orderStatusUpdate from "./6.2_orderStatusUpdate.json";
import cancelOrder from "./6.3_cancelOrder.json";
import orderQueryOther from "./6.4_orderQueryOther.json";
import deliveryQueryData from "./7_deliveryQuery.js";
import amendDelivery from "./7.1_amendDelivery.json";
import trackDelivery from "./7.2_trackDelivery.json";
import damagedOnDeliveryNonFurniture from "./7.3_damagedOnDeliveryNonFurniture.json";
import damagedOnDeliveryFurniture from "./7.4_damagedOnDeliveryFurniture.json";
import deliveryQueryOther from "./7.5_deliveryQueryOther.json";
import gasOrWaterLeak from "./7.6_gasOrWaterLeak.json";
import missingItem from "./7.7_missingItem.json";
import giftCard from "./8_giftCard.json";
import giftCardPurchased from "./8.1_giftCardPurchased";
import claimingGiftCard from "./8.2_claimingGiftCard.json";
import imageUploadTest from "./12_imageUpload.json";
import shopLostProperty from "./10_shopLostProperty.json";
import websiteFeedback from "./11_websiteFeedback";
import damagePropertyOrPersonalInjury from "./13_damagePropertyOrPersonalInjury.json";
import personalInjury from "./13.1_personalInjury.json";
import damageToProperty from "./13.2_damageToProperty.json";
import financialService from "./14_financialService.json";
import insurance from "./14.3_insurance.json";
import banking from "./14.1_banking.json";
import partnershipCard from "./14.2_partnershipCard.json";

const emailUsData = (escalatedComplaintsEnabled, otherEmailOptionEnabled, missingItemEmailFormEnabled) => ({
  subjects: subjectsData(escalatedComplaintsEnabled),
  deliveryQuery: deliveryQueryData(escalatedComplaintsEnabled, missingItemEmailFormEnabled),
  problemsWithProduct: problemsWithProductData(escalatedComplaintsEnabled),
  onlineOrShop,
  shop,
  liveChat,
  productAndStockInformation,
  storeStockAvailability,
  productInformation,
  myJLMembership,
  furnitureDamagedOnDelivery,
  furnitureProductFault,
  electrical,
  problemsOther,
  returns,
  returnsShop,
  returnsOnline,
  refunds,
  refundsShop,
  refundsOnline,
  orderQuery: orderQueryData(otherEmailOptionEnabled),
  amendOrder,
  orderStatusUpdate,
  cancelOrder,
  orderQueryOther,
  amendDelivery,
  trackDelivery,
  damagedOnDeliveryNonFurniture,
  damagedOnDeliveryFurniture,
  deliveryQueryOther,
  giftCard,
  giftCardPurchased,
  claimingGiftCard,
  shopLostProperty,
  websiteFeedback,
  imageUploadTest,
  gasOrWaterLeak,
  missingItem,
  damagePropertyOrPersonalInjury,
  personalInjury,
  damageToProperty,
  financialService,
  infestation,
  insurance,
  banking,
  partnershipCard,
});

export default emailUsData;
